/**
 * Map zoom levels
 */
export const MAP_ZOOM_LEVELS = {
  DEFAULT: 10,
  FIELD: 11,
  FARM: 11
} as const;

/**
 * Drawer dimensions
 */
export const DRAWER_DIMENSIONS = {
  WIDTH: '84%',
  FOOTER_HEIGHT: '80px'
} as const;

/**
 * Map colors for focused/selected fields
 */
export const MAP_COLORS = {
  FOCUSED_FILL: 'rgba(49, 180, 242, 0.4)',
  FOCUSED_OUTLINE: 'rgba(49, 180, 242, 1)',
  TEXT_SECONDARY: '#696F88',
  CLOSE_BUTTON: '#696F88'
} as const;

/**
 * Layout dimensions
 */
export const LAYOUT = {
  LEFT_PANEL_WIDTH: 'w-2/5',
  MAP_PANEL_WIDTH: 'w-3/5'
} as const;
